import { CORP_CLIENT_LIST, POC_LIST,MEETING_SITES,CORP_CLIENT_EMAIL,MOM_LISTING, BA_OPPORTUNITY_FROM_LEADX } from "./type";

const initialState = {
  corpClientList: [],
  corpClientPoc: [],
  meetingSites: [],
  corpClientEmail: [],
  getMomListing: [],
  opportunityList:[]
};

const CorpClientReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CORP_CLIENT_LIST:
      return {
        ...state,
        corpClientList: payload,
      };
    case MEETING_SITES:
      return {
        ...state,
        meetingSites: payload,
      };
    case POC_LIST:
      return {
        ...state,
        corpClientPoc: payload,
      };
    case CORP_CLIENT_EMAIL:
        return {
          ...state,
          corpClientEmail: payload,
        }; 
    case MOM_LISTING:
        return {
          ...state,
          getMomListing: payload,
        };
    case BA_OPPORTUNITY_FROM_LEADX:
      return {
        ...state,
        opportunityList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default CorpClientReducer;
